<template>
  <div
    :data-campanha="campanha.id"
    class="accordion-item"
    :class="[
      { 'accordion-active': campanha.active },
      campaignStatus ? `status-${campaignStatus}` : '',
    ]"
  >
    <div class="accordion-header">
      <a class="accordion-header-button" @click="expand($event)">
        <div class="accordion-header-content">
          <div class="accordion-left-column">
            <IconMaxDesconto
              :grupos-bonus="campanha.grupos_bonus"
              :display-discount="campanha.display_max_discount"
            />
          </div>
          <div class="accordion-right-column">
            <div
              v-if="campaignStatus"
              :class="['status-badge', `status-badge-${campaignStatus}`]"
            >
              <div
                :class="[
                  'status-badge-icon',
                  `status-badge-icon-${campaignStatus}`,
                ]"
              >
                <i
                  v-if="campaignStatus === 'notAcquired'"
                  class="fa fa-circle-o"
                ></i>
                <svg
                  v-else-if="campaignStatus === 'partial'"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="8"
                    cy="8"
                    r="6"
                    stroke="currentColor"
                    stroke-width="1.5"
                    fill="none"
                  />
                  <path
                    d="M 2 8 A 6 6 0 1 0 14 8 L 8 8 Z"
                    fill="currentColor"
                  />
                </svg>
                <i
                  v-else-if="campaignStatus === 'acquired'"
                  class="fa fa-check-circle"
                ></i>
              </div>
              <span class="status-badge-text">
                <template v-if="campaignStatus === 'notAcquired'"
                  >Não Iniciada</template
                >
                <template v-else-if="campaignStatus === 'partial'"
                  >Falta pouco</template
                >
                <template v-else-if="campaignStatus === 'acquired'"
                  >Conquistada</template
                >
              </span>
            </div>
            <div class="accordion-header-label">
              <h3 class="campaign-title">{{ campanha.descricao }}</h3>
              <div class="campaign-validity">
                {{ `Campanha válida até ${parseDateTime(campanha.dtfim)}  ` }}
                <span class="separator">-</span>
                <span
                  v-if="campanha.modelo_desconto == 'acumulado'"
                  class="campaign-discount-info"
                >
                  Esta oferta é cumulativa
                  <TooltipBalloon
                    :text="'Caso um produto participante desta oferta, seja ativado em um duas ou mais ofertas, os descontos irão acumular (somar), respeitando a regra de cada oferta.'"
                  >
                    <alert-circle-icon size="1.5x" class="custom-class" />
                  </TooltipBalloon>
                </span>
                <span v-else class="campaign-discount-info">
                  Esta oferta não acumula
                  <TooltipBalloon
                    :text="'Caso um produto participante desta oferta, seja ativado em duas ou mais ofertas, irá prevalecer o maior desconto entre as ofertas.'"
                  >
                    <alert-circle-icon size="1.5x" class="custom-class" />
                  </TooltipBalloon>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Linha superior para mobile < 340px -->
        <div class="accordion-header-top-row">
          <div
            v-if="campaignStatus"
            :class="['status-badge', `status-badge-${campaignStatus}`]"
          >
            <div
              :class="[
                'status-badge-icon',
                `status-badge-icon-${campaignStatus}`,
              ]"
            >
              <i
                v-if="campaignStatus === 'notAcquired'"
                class="fa fa-circle-o"
              ></i>
              <svg
                v-else-if="campaignStatus === 'partial'"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="8"
                  cy="8"
                  r="6"
                  stroke="currentColor"
                  stroke-width="1.5"
                  fill="none"
                />
                <path d="M 2 8 A 6 6 0 1 0 14 8 L 8 8 Z" fill="currentColor" />
              </svg>
              <i
                v-else-if="campaignStatus === 'acquired'"
                class="fa fa-check-circle"
              ></i>
            </div>
            <span class="status-badge-text">
              <template v-if="campaignStatus === 'notAcquired'"
                >Não iniciada</template
              >
              <template v-else-if="campaignStatus === 'partial'"
                >Falta pouco</template
              >
              <template v-else-if="campaignStatus === 'acquired'"
                >Ativada</template
              >
            </span>
          </div>
          <div class="accordion-left-column-mobile">
            <IconMaxDesconto
              :grupos-bonus="campanha.grupos_bonus"
              :display-discount="campanha.display_max_discount"
            />
          </div>
        </div>
        <div class="accordion-caret-wrapper">
          <div class="accordion-caret"></div>
        </div>
      </a>
    </div>

    <div :ref="'accordion-body'" class="accordion-body">
      <div v-if="campanha.active" class="accordion-content">
        <div class="headerContent" :class="1 ? 'noBanner' : ''">
          <CardBannerHeader :campanha="campanha" />
          <div class="description">
            <div v-if="objetoImagens && objetoImagens.length > 0">
              <img
                v-if="isMobile"
                :src="getMobileImageUrl"
                alt="Imagem Mobile"
              />
              <img v-else :src="getDesktopImageUrl" alt="Imagem Desktop" />
            </div>
            <h4>Descrição:</h4>
            <span>
              <span v-if="campanha.descricao_completa">
                {{ campanha.descricao_completa }}
              </span>
              <span v-else>
                Ganhe
                {{
                  campanha.display_max_discount &&
                  `até ${campanha.display_max_discount} de `
                }}desconto em itens selecionados, completando os combos de
                produtos abaixo no período de
                {{ parseDateTime(campanha.dtinicio) }} até
                {{ parseDateTime(campanha.dtfim) }}. Depois é só visualizar os
                produtos participantes da promoção e adicionar eles ao seu
                carrinho para garantir seu desconto.
                <template v-if="campanha.qtd_max_prod_participantes">
                  Mensalmente, você terá uma quantidade máxima de
                  {{ campanha.qtd_max_prod_participantes }} produtos,
                </template>
                <template v-if="campanha.valor_max_prod_participantes">
                  e um valor máximo de
                  {{
                    "R$ " + mascaraValor(campanha.valor_max_prod_participantes)
                  }}
                  nos produtos participantes.
                </template>
              </span>
            </span>
          </div>
        </div>
        <div class="bodyContent">
          <div v-if="campanha.active" class="combosAtivacao">
            <ComboAtivacaoCard
              v-for="(comboAtivacao, index) in campanha.grupos_ativacao"
              :key="index"
              :index="index + 1"
              :combo-ativacao="comboAtivacao"
              :campanha-id="campanha.id"
            />
          </div>

          <div v-if="campanha.active" class="produtosBonusContent">
            <ProdutosBonusCard :campanha="campanha" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AlertCircleIcon from "vue-feather-icons/icons/AlertCircleIcon";
import gsap from "gsap";
import { format } from "date-fns";
import CardValorMinimo from "./CardValorMinimo.vue";
import { mascaraValor } from "@/app/global.js";
import ComboStage from "@/components/combo-campanhas/ComboStage.vue";
import IconMaxDesconto from "@/components/campanhas/IconMaxDesconto.vue";
import SliderCampanha from "@/components/combo-campanhas/SliderCampanha";
import ComboAtivacaoCard from "./ComboAtivacaoCard.vue";
import ProdutosBonusCard from "./ProdutosBonusCard.vue";
import TooltipBalloon from "@/components/tooltip-balloon/TooltipBalloon.vue";
import CardBannerHeader from "./components/CardBannerHeader/CardBannerHeader.vue";

export default {
  name: "CampanhaAccordion",
  components: {
    ComboStage,
    IconMaxDesconto,
    SliderCampanha,
    ComboAtivacaoCard,
    ProdutosBonusCard,
    CardValorMinimo,
    AlertCircleIcon,
    TooltipBalloon,
    CardBannerHeader,
  },
  props: {
    campanha: {
      type: Object,
    },
    active: { type: Number },
    handleAccordionActive: {},
  },
  data() {
    return {
      objetoImagens: [],
      showContent: false,
      produtosBonusContent: [],
      gruposAtivacao: [],
      isMobile: null,
    };
  },
  computed: {
    watchActive() {
      return this.active;
    },
    getMobileImageUrl() {
      if (!this.objetoImagens || !this.objetoImagens.length) return "";
      var mobileImage = this.objetoImagens.find(
        (imagem) => imagem.tipo === "M"
      );
      if (!mobileImage) {
        var desktopImage = this.objetoImagens.find(
          (imagem) => imagem.tipo === "D"
        );
      }
      return mobileImage
        ? mobileImage.src
        : desktopImage
        ? desktopImage.src
        : "";
    },
    getDesktopImageUrl() {
      if (!this.objetoImagens || !this.objetoImagens.length) return "";
      var desktopImage = this.objetoImagens.find(
        (imagem) => imagem.tipo === "D"
      );
      return desktopImage ? desktopImage.src : "";
    },
    hubPromotions() {
      return this.$store.getters.hubPromotions || [];
    },
    campaignStatus() {
      if (!this.hubPromotions || this.hubPromotions.length === 0) {
        return null;
      }

      const campanhaId = String(this.campanha.id || this.campanha.code || "");
      const promotion = this.hubPromotions.find(
        (promo) => String(promo.code) === campanhaId
      );

      return promotion ? promotion.status : null;
    },
  },
  watch: {
    watchActive(newValue) {
      if (newValue != this.campanha.id) {
        this.handleExpand();
      }
    },
  },
  mounted() {
    // this.getValueProducts();
    this.handleExpand();

    this.objetoImagens =
      this.campanha?.promocao_imagem || this.campanha?.promocaoImagem || [];

    window.addEventListener("resize", this.tamanhoTela);
    this.isMobile = window.innerWidth < 768;
  },
  methods: {
    tamanhoTela() {
      this.isMobile = window.innerWidth < 768;
    },
    mascaraValor,
    getMaxDiscount(bonus = []) {
      let discount = 0;
      let tpDesconto = 1;
      if (bonus.length > 0) {
        bonus.forEach((bonusItem) => {
          if (parseFloat(bonusItem.vlrdesconto) > discount) {
            discount = parseFloat(bonusItem.vlrdesconto);
            tpDesconto = bonusItem.tpdesconto;
          }
        });
      }

      if (tpDesconto == 1) {
        discount = `${discount}%`;
      } else {
        discount = `R$ ${mascaraValor(discount)}`;
      }
      return discount;
    },
    handleExpand() {
      this.campanha.active = false;
      const el = this.$refs["accordion-body"];

      //! todo implementar função nativa para definir posição da página de acordo com o accordion aberto.
      gsap.to(el, {
        height: 0,
        duration: 2,
        ease: "sine",
      });
    },
    expand(e) {
      const el = this.$refs["accordion-body"];
      if (!this.campanha.active) {
        this.campanha.active = true;

        //! todo implementar função nativa para definir posição da página de acordo com o accordion aberto.
        gsap.to(el, {
          height: "100%",
          duration: 2,
          ease: "elastic(1, 0.3)",
        });

        const contentAccordion = document.querySelector(".accordion-content");

        if (contentAccordion) {
          const bodyRect = document.body.getBoundingClientRect();
          const elemRect = contentAccordion.getBoundingClientRect();
          const offset = elemRect.top - bodyRect.top;

          window.scrollTo({
            top: offset,
            behavior: "smooth",
          });
        }

        this.$store.dispatch("setCampanhaStatus");
        this.handleAccordionActive(this.campanha.id);
      } else {
        this.campanha.active = false;
        //! todo implementar função nativa para definir posição da página de acordo com o accordion aberto.
        gsap.to(el, {
          duration: 2,
          height: 0,
          ease: "sine",
        });
      }
    },
    parseDateTime(date, type = "date") {
      if (type == "date") {
        return format(new Date(date), "dd/MM/yy");
      }
      // return format(parse(date, "hh:mm:ss"), "hh:mm:ss");
      return format(new Date(date), "hh:mm");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/global.css";
@import "~@/assets/css/sass/bootstrap/variables";
$base-color: #727272;
$base-width: 100%;
$base-time: 200ms;

$app-background-color: #82dfff;
$app-padding: 2rem;
$accordion-item-background-color: #fff;
$accordion-item-border-radius: 6px;
$accordion-item-margin-bottom: 50px;

$accordion-background-color: transparent;
$accordion-max-width: $base-width;
$accordion-padding: 0;
$accordion-border-radius: 0.5rem;
$accordion-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);

$accordion-header-font-size: 1.2rem;
$accordion-header-height: 2rem;
$accordion-header-padding: 1rem 1rem 1rem 1rem;
$accordion-header-border-radius: 0.6rem;
$accordion-header-transition: background-color $base-time ease-in-out;

$accordion-header-hover-background-color: #efefef;

$accordion-caret-color: $base-color;
$accordion-caret-background-image: linear-gradient(
  to top right,
  transparent 50%,
  $accordion-caret-color 50%
);
$accordion-caret-width: 0.7rem;
$accordion-caret-height: 0.7rem;
$accordion-caret-transform: rotate(-45deg);
$accordion-caret-transforming: scale(1.5) rotate(45deg);
$accordion-caret-active-transform: rotate(135deg);

$accordion-body-content-padding: 0px 20px 20px 20px;

@import url("https://fonts.googleapis.com/css?family=Montserrat:400,400i,700");

.accordion-header-button {
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition: all 200ms ease-in;
}

.accordion-item {
  background-color: #fff;
  width: 100%;
  max-width: $accordion-max-width;
  margin: auto;
  box-sizing: border-box;
  overflow: visible;
  border-radius: 6px;
  margin-bottom: 24px;
  border: 1px solid #e5e5e5;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  font-family: "Open Sans", sans-serif;
  position: relative;
  transition: all 200ms ease-in;

  // Faixa lateral de status
  &.status-notAcquired {
    border-left: 4px solid #e0e0e0;
  }

  &.status-partial {
    border-left: 4px solid $brand-warning;
  }

  &.status-acquired {
    border-left: 4px solid $brand-success;
  }

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    transform: translateY(-1px);

    &.status-notAcquired {
      border-left-width: 5px;
    }

    &.status-partial {
      border-left-width: 5px;
    }

    &.status-acquired {
      border-left-width: 5px;
    }

    .status-badge {
      transform: scale(1.02);
    }
  }
}

.accordion-item.accordion-active {
  .accordion-caret {
    transform: rotate(180deg);
  }
}

.accordion-header {
  color: inherit;
  font-size: $accordion-header-font-size;
  position: relative;
  padding: 24px 32px;

  a {
    color: inherit;
    text-decoration: none;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }
}

.accordion-header-content {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 24px;
  flex: 1;
  min-width: 0; // Permite que o conteúdo encolha
  padding-right: 8px; // Espaçamento extra antes do chevron
}

.accordion-header-top-row {
  display: none; // Escondido por padrão, aparece apenas em < 340px
}

// Coluna fixa do desconto para manter alinhamento em todos os cards
.accordion-left-column {
  flex-shrink: 0;
  width: 128px;
  min-width: 128px;
  max-width: 128px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.accordion-left-column-mobile {
  display: none;
}

.accordion-right-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  min-width: 0; // Permite que o texto encolha e não empurre o chevron
  padding-right: 12px; // Espaçamento adicional antes do chevron
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  width: fit-content;
  transition: transform 200ms ease-in;

  .status-badge-icon {
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 12px;
      height: 12px;
      display: block;
      flex-shrink: 0;
    }
  }

  &.status-badge-notAcquired {
    background: rgba(224, 224, 224, 0.2);
    color: #979797;

    .status-badge-icon {
      color: #979797;
    }
  }

  &.status-badge-partial {
    background: rgba(232, 151, 21, 0.15);
    color: $brand-warning;

    .status-badge-icon {
      color: $brand-warning;
    }
  }

  &.status-badge-acquired {
    background: rgba(28, 155, 94, 0.15);
    color: $brand-success;

    .status-badge-icon {
      color: $brand-success;
    }
  }
}

.accordion-header-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.campaign-title {
  margin: 0;
  color: #303932;
  font-size: 17px;
  font-weight: 700;
  line-height: 24px;
  text-transform: capitalize;
  font-family: "Open Sans", sans-serif;
  padding-right: 8px; // Espaçamento extra para não grudar no chevron
  word-break: break-word; // Quebra palavras longas se necessário
}

.campaign-validity {
  font-weight: normal;
  color: #7b8580;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;

  .campaign-discount-info {
    display: flex;
    align-items: center;
    gap: 3px;
    svg:hover {
      transition: 0.3s;
      color: #303932;
    }
  }
}

.accordion-caret-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 20px; // Aumentado de 16px para 20px
  border-radius: 50%;
  transition: background-color 200ms ease-in;

  &:hover {
    background-color: #f5f5f5;
  }
}

.accordion-caret {
  width: 8px;
  height: 8px;
  border-right: 2px solid #727272;
  border-bottom: 2px solid #727272;
  transform: rotate(45deg);
  transition: transform 200ms ease-in;
}

.accordion-body {
  height: 0;
  overflow: hidden;
  width: 100%;
  margin: 0;
}

.accordion-content {
  padding: 24px 32px;
  border-top: 1px solid #e5e5e5;

  .headerContent {
    margin-bottom: 24px;

    .description {
      margin: 20px 0;
      img {
        max-width: 100%;
        padding-bottom: 20px;
        border-radius: 4px;
      }
      h4 {
        margin: 0;
        margin-bottom: 12px;
        color: #303932;
        font-weight: 700;
        font-size: 16px;
        font-family: "Open Sans", sans-serif;
      }
      span {
        color: #6d6d6d;
        font-size: 14px;
        line-height: 1.6;
        font-family: "Open Sans", sans-serif;
      }
    }
  }

  .bodyContent {
    .combosAtivacao {
      margin-bottom: 24px;
    }

    .produtosBonusContent {
      margin-top: 24px;
      padding-top: 24px;
      border-top: 1px solid #e5e5e5;
    }
  }

  .noBanner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;

    .description {
      grid-column: 1;
      grid-row: 1;
    }
    .headContentDetails {
      grid-column: 2;
    }
  }
}
@media (max-width: 768px) {
  .accordion-header {
    padding: 20px 24px;
  }

  .accordion-header-content {
    gap: 16px;
  }

  .accordion-content {
    padding: 20px 24px;

    .headerContent {
      .description {
        margin: 16px 0;
      }
    }

    .bodyContent {
      .combosAtivacao {
        margin-bottom: 20px;
      }

      .produtosBonusContent {
        margin-top: 20px;
        padding-top: 20px;
      }
    }

    .noBanner {
      display: initial;
      gap: 0;
    }
  }

  .campaign-title {
    font-size: 16px;
    line-height: 22px;
  }
}

@media (max-width: 650px) {
  .accordion-header {
    padding: 16px 20px;
  }

  .accordion-header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .accordion-left-column {
    width: 100%;
    justify-content: center;
    min-height: 100px;
  }

  .accordion-right-column {
    width: 100%;
  }

  .accordion-caret-wrapper {
    position: absolute;
    top: 16px;
    right: 20px;
  }

  .campaign-validity {
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: flex-start;
    gap: 4px;
    font-size: 12px;

    span.separator {
      display: none;
    }
  }

  .status-badge {
    font-size: 10px;
    padding: 3px 8px;

    .status-badge-icon {
      svg {
        width: 10px;
        height: 10px;
      }
    }
  }

  .accordion-content {
    padding: 16px 20px;
  }
}

@media (max-width: 340px) {
  .accordion-header {
    padding: 12px 16px;
    position: relative;
  }

  .accordion-header-button {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .accordion-header-content {
    flex-direction: column;
    gap: 8px;
    width: 100%;

    // Esconde o layout original em telas pequenas
    .accordion-left-column {
      display: none;
    }

    .accordion-right-column {
      width: 100%;

      .status-badge {
        display: none; // Esconde do layout original
      }
    }
  }

  // Linha 1: Status badge (esquerda) + Desconto (direita)
  .accordion-header-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 8px;
    flex-shrink: 0;
    margin-bottom: 8px;

    .status-badge {
      display: inline-flex;
      font-size: 9px;
      padding: 3px 6px;
      gap: 4px;
      flex-shrink: 0;
      order: 1;

      .status-badge-icon {
        font-size: 10px;

        svg {
          width: 9px;
          height: 9px;
        }
      }

      .status-badge-text {
        white-space: nowrap;
      }
    }

    .accordion-left-column-mobile {
      display: flex;
      order: 2;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 110px;
      min-width: 110px;
      min-height: 80px;
    }
  }

  .accordion-header-label {
    width: 100%;
    margin-top: 0;
  }

  .campaign-title {
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    max-height: 36px; // 2 linhas × 18px
  }

  .campaign-validity {
    font-size: 11px;
    margin-top: 4px;
    display: none; // Esconde em telas muito pequenas, aparece quando expandido
  }

  .accordion-item.accordion-active {
    .campaign-validity {
      display: flex; // Mostra quando accordion está aberto
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
    }
  }

  .accordion-caret-wrapper {
    position: absolute;
    top: 12px;
    right: 16px;
    width: 28px;
    height: 28px;
    margin: 0;
  }

  .accordion-content {
    padding: 12px 16px;

    .headerContent {
      .description {
        margin: 12px 0;

        h4 {
          font-size: 14px;
          margin-bottom: 8px;
        }

        span {
          font-size: 12px;
        }
      }
    }

    .bodyContent {
      .combosAtivacao {
        margin-bottom: 16px;
      }

      .produtosBonusContent {
        margin-top: 16px;
        padding-top: 16px;
      }
    }
  }
}

@media screen and (min-width: $base-width) {
  #app {
    padding: $app-padding;
    overflow: auto;
  }

  .accordion {
    max-height: none;
    border-radius: $accordion-border-radius;
  }
}
</style>
